import React from 'react';

interface CustomPolarTickProps {
  payload: {
    value: string;
  };
  x: number;
  y: number;
  textAnchor: string;
}

const CustomPolarTick: React.FC<CustomPolarTickProps> = ({ payload, x, y, textAnchor }) => {
  const label = payload.value;
  const maxLength = 35;

  const words = label.split(' ');

  const lines: string[] = [];
  let currentLine = '';

  words.forEach(word => {
    if (currentLine.length + word.length <= maxLength) {
      currentLine += (currentLine ? ' ' : '') + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  });

  if (currentLine) {
    lines.push(currentLine);
  }

  return (
    <text x={x} y={y} textAnchor={textAnchor} fontSize={16} fontWeight={500} fill="#828282">
      {lines.map((line, index) => (
        <tspan key={index} x={x} dy={index === 0 ? 0 : 16}>
          {line}
        </tspan>
      ))}
    </text>
  );
};

export default CustomPolarTick;
